import { render, staticRenderFns } from "./RecordVideo.vue?vue&type=template&id=7f7d8e6a"
import script from "./RecordVideo.vue?vue&type=script&lang=js"
export * from "./RecordVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports